import { render, staticRenderFns } from "./OmsHeader.vue?vue&type=template&id=515b926e&scoped=true"
import script from "./OmsHeader.vue?vue&type=script&lang=js"
export * from "./OmsHeader.vue?vue&type=script&lang=js"
import style0 from "./OmsHeader.vue?vue&type=style&index=0&id=515b926e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b926e",
  null
  
)

export default component.exports